<div class="row">
  <app-sidebar class="col-2"></app-sidebar>
  <div class="col me-2 scrollable main-content">
    <router-outlet></router-outlet>
  </div>
</div>
